// Polyfills for older browsers
if (typeof window !== 'undefined') {
  // Add any polyfills needed for older browsers
  if (!window.Promise) {
    const PromisePolyfill = require('promise-polyfill');
    window.Promise = PromisePolyfill;
  }
  
  if (!window.fetch) {
    const FetchPolyfill = require('whatwg-fetch');
    window.fetch = FetchPolyfill.fetch;
  }
  
  if (!window.IntersectionObserver) {
    require('intersection-observer');
  }
  
  // Add CSS custom properties polyfill for IE11
  if (window.navigator.userAgent.indexOf('MSIE ') > 0 || 
      window.navigator.userAgent.indexOf('Trident/') > 0) {
    require('css-vars-ponyfill').default();
  }
}

// Make this file a module
export {}; 